import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import uuid from 'uuid/v1';
import Slider, { SLIDER_LAYOUT_DESTINATION, SLIDER_LAYOUT_TICKETS } from './Slider';
import { copy, reorder } from '../../../../utils/dragAndDrop';
import CarouselContentSchedule from './CarouselContentSchedule';


/*
const n = 8; // Or something else

[...Array(n)].map((e, i) => <Slider>♦</Slider>)
*/
const grid = 4;

const sliderElements = 0;

const itemsModules = [
  {
    id: uuid(),
    content: 'SliderBannerHome',
    readableName: 'Slider',
    type: 'item',
  },
];

const getItemStyleContent = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  color: 'white',
  padding: grid * 4,
  margin: `0 0 ${grid}px 0`,
  borderRadius: '4px',

  // change background colour if dragging
  background: isDragging ? 'lightgreen' : '#292929',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getItemStyleType = (isDragging, draggableStyle, selected) => ({
  minHeight: selected.length === 0 && '70px',
  display: selected.length === 0 && 'flex',
  justifyContent: selected.length === 0 && 'center',
  alignItems: selected.length === 0 && 'center',
  padding: selected.length === 0 && 0,
  userSelect: 'none',
  // padding: grid * 4,
  border: '1px solid #dae1e7',
  borderRadius: '10px',
  marginTop: '10px',

  // change background colour if dragging
  background: 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyleContent = isDraggingOver => ({
  background: 'black',

  padding: grid,
  width: '100%',
});

const getListStyleType = isDraggingOver => ({
  background: isDraggingOver ? 'black' : 'white',
  borderRadius: '10px',
  // padding: grid,
  width: '100%',
});

const initialState = {
  type: 'Carousel',
  slugName: 'homeCarousel',
  section: 'home',
  components: [],
  areSlidesShort: false,
  isFooterSlider: false,
  maxChildComponents: 0,
};

const Carousel = ({
  activeLanguage,
  handlerSetComponents,
  components,
  id,
  reusableComponent,
  reusableComponentSlugname,
  languages,
  handlerSetCarouselComponents,
  selectedOnDragAndDrop,
}) => {
  // console.log('components Carousel', components[0].component.components[0].component);
  const [state, setState] = useState(initialState);
  const [item] = useState(itemsModules);
  const [selected, setSelected] = useState([]);
  const [carouselIndex, setIndex] = useState();
  const [areSlidesShort, setAreSlidesShort] = useState(false);
  const [isFooterSlider, setIsFooterSlider] = useState(false);
  const [showItem, setShowItem] = useState([]);
  const [isRecord, setIsRecord] = useState("SliderBannerHome");
  const [maxChildComponents, setMaxChildComponents] = useState(0);
  const [showItemsLimit, setShowItemsLimit] = useState(0);

  const handlerSetScheduleDate = (comp, index, date, name) => {
    if (!selected[index] || !selected[index].component) {
      return;
    }
    const newSelected = selected;
    newSelected[index].component[name] = date;
    handlerSetCarouselComponents(newSelected, carouselIndex);
  };

  const handlerSetSlider = (comp, index) => {
    const { component } = comp;

    const newSelected = selected;
    newSelected[index].component = { ...component };

    setSelected(newSelected);
  };

  const handleBlockClose = (id) => {
    const itemToBeRemovedIndex = selected.map(i => i.id).indexOf(id.toString());
    const arr = [...selected];
    arr.splice(itemToBeRemovedIndex, 1);
    setSelected(arr);
    handlerSetCarouselComponents(arr, carouselIndex);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    // NOTE: check transformCarouselToDnD to add or remove new props.

    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) {
        handlerSetComponents(
          { component: { key: reusableComponentSlugname } },
          componentIndex,
        );
      }
    } else {
      setIndex(componentIndex);
      if (component) {
        const { components: currentComponent } = component;
        const { type } = currentComponent.length > 0 && currentComponent[0].component ? currentComponent[0].component : false;
        if (type) { console.log("component", type, currentComponent[0], isRecord); setIsRecord(type); }
        setState(component);
        setAreSlidesShort((component.areSlidesShort) || false);
        setIsFooterSlider((component.isFooterSlider) || false);
        setMaxChildComponents((component.maxChildComponents) || 0);
      } else {
        const componentObj = {
          id,
          component: state,
        };
        handlerSetComponents(componentObj, componentIndex);
      }
    }

    if (selectedOnDragAndDrop.length > 0 && components[componentIndex]) {
      setSelected(components[componentIndex].component.components);
    }
  }, [components]);

  const copySlide = () => {
    const source = {
      droppableId: 'items',
      index: 0,
    };

    const destination = {
      droppableId: 'selected',
      index: selected.length,
    };

    const makeCopy = copy(item, selected, source, destination);
    setSelected(makeCopy);
  };

  const onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    switch (source.droppableId) {
      case destination.droppableId: {
        const newOrder = reorder(selected, source.index, destination.index);
        // handlerSetSelectedComponents(newOrder); // push changes to parent container
        setSelected(newOrder);
        const stateWithRearrangedComponets = { ...state, components: newOrder };
        setState(stateWithRearrangedComponets);
        const componentIndex = components.findIndex(obj => obj.id === id);
        const componentObj = {
          id,
          component: stateWithRearrangedComponets,
        };
        handlerSetComponents(componentObj, componentIndex);
        break;
      }
      case 'items': {
        if (destination.droppableId === 'selectedLeft') {
          const makeCopy = copy(items2, selectedLeft, source, destination);
          setSelected(makeCopy);
          break;
        } else {
          const makeCopy = copy(items2, selectedRight, source, destination);
          setSelected(makeCopy);
          break;
        }
        // handlerSetSelectedComponents(makeCopy); // push changes to parent container
      }
      default: {
        break;
      }
    }
  };

  const handleShorterHeight = () => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const comp = {
      ...state,
      areSlidesShort: !areSlidesShort,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, componentIndex);
    setAreSlidesShort(!areSlidesShort);
  };

  const handleSetIsFooterSlider = () => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const comp = {
      ...state,
      isFooterSlider: !isFooterSlider,
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, componentIndex);
    setIsFooterSlider(!isFooterSlider);
  };


  const handleSetShowItemsLimit = (value) => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const comp = {
      ...state,
      maxChildComponents: parseInt(value, 10),
    };

    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, componentIndex);
    setMaxChildComponents(value);
  };

  const handleIsRecord = (e) => {
    const { value } = e.target;
    setIsRecord(value);
  };
  
  const setVisibleItemFromDragBox = (id) => {
    showItem[id] = !showItem[id];
    setShowItem({ ...showItem });
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="flex justify-between text-black rounded-t border-1 p-4">
        {/* Toggle */}
        <div className="flex items-center">
          <label htmlFor="toggleValue" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Small layout</label>
          <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
            <input
              type="checkbox"
              name="toggleValue"
              value="checkedA"
              onChange={handleShorterHeight}
              checked={areSlidesShort}
              className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
            />
            <label htmlFor="toggleValue" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
          </div>
        </div>
        {/* End Toggle */}
        {/* Toggle */}
        <div className="flex items-center">
          <label htmlFor="footerToggle" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Fixed at footer</label>
          <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
            <input
              type="checkbox"
              name="footerToggle"
              value="checkedA"
              onChange={handleSetIsFooterSlider}
              checked={isFooterSlider}
              className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
            />
            <label htmlFor="footerToggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
          </div>
        </div>
        {/* End Toggle */}
        <div className="flex items-center">
          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2" htmlFor="maxChildComponents">
            Max. displayed items
          </label>
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            id="maxChildComponents"
            onChange={e => handleSetShowItemsLimit(e.target.value)}
            value={maxChildComponents}
          >
            {
              Array.from(Array(20 + 1)).map((_, ind) => (
                <option value={ind} key={ind}>
                  {/* {' '} */}
                  {ind || 'All'}
                  {/* {' '} */}
                </option>
              ))
            }
          </select>
        </div>
        {/* Toggle */}
        <div className="flex items-center">
          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2" htmlFor="grid-state">
            Layout
          </label>
          <div className="relative">
            <select
              className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
              value={isRecord}
              onChange={handleIsRecord}
            >
              <option value={"SliderBannerHome"}>Normal</option>
              <option value={"SliderBannerRecords"}>Records</option>
              <option value={SLIDER_LAYOUT_TICKETS}>Tickets</option>
              <option value={SLIDER_LAYOUT_DESTINATION}>Destination</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                /></svg>
            </div>
          </div>
        </div>
        {/* End Toggle */}


      </div>

      <div
        className="flex items-center w-full rounded-b bg-blue-darker mb-4"
      >
        <button
          type="button"
          onClick={copySlide}
          className="text-white text-xs font-bold h-10 w-full uppercase flex items-center justify-center"
        >
          Add slide
          {' '}
          <span className="font-icon icon-add-button text-base font-bold pl-2" />
        </button>
      </div>

      <div className="w-full h-full">
        <Droppable droppableId="selected">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyleType(snapshot.isDraggingOver)}
            >
              {selected.length > 0
                && selected.map((item, index) => (
                  <Draggable
                    key={item.id}
                    draggableId={item.id}
                    index={index}
                    activeLanguage={activeLanguage}
                  >
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        style={getItemStyleType(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                          selected,
                        )}
                        className="relative"
                      >

                        <div className={`w-full p-4`}>
                          <div className="flex justify-between" {...provided.dragHandleProps}>
                            <button
                              className="bg-blue-darker block
                              font-bold p-2 rounded text-white text-xs
                              tracking-wide uppercase
                              relative pr-8"
                              type="button"
                              onClick={() => setVisibleItemFromDragBox(item.id)}
                            >
                              {item.readableName}
                              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-10 top-0">
                                <svg
                                  className={`fill-current h-4 w-4 ${showItem[item.id] ? 'rotate-180' : ''}`}
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  /></svg>
                              </div>
                            </button>
                            <span style={{ marginLeft: 'auto' }} className="mr-2">
                              <CarouselContentSchedule component={item} index={index} handlerSetScheduleDate={handlerSetScheduleDate} name="scheduledDate" title="Activation date" />
                            </span>
                            <span className="mr-2">
                              <CarouselContentSchedule component={item} index={index} handlerSetScheduleDate={handlerSetScheduleDate} name="expirationDate" title="Expiration date" />
                            </span>
                            <button
                              className="bg-blue-darker font-bold p-2 rounded tracking-wide"
                              type="button"
                              onClick={() => {
                                handleBlockClose(item.id);
                              }}
                            >
                              <span className="font-icon icon-close-btn1 text-base text-white" />
                            </button>
                          </div>
                        </div>
                        <div className="relative">
                          {showItem[item.id] && (
                          // {/* {
                          // // (item.content === 'SliderBannerHome' ||
                          // // item.content === 'SliderBannerRecords')
                          // // && ( */}
                            <div className={`border-grey-lighter border-t-1 flex w-full`}>
                              <div
                                className="bg-greyFilterItems rounded flex items-center justify-center w-10 text-greyFilter"
                                {...provided.dragHandleProps}
                              >=</div>
                              <div className="w-full relative">
                                <Slider
                                  areSlidesShort={areSlidesShort}
                                  carouselIndex={carouselIndex}
                                  languages={languages}
                                  handlerSetCarouselComponents={
                                    handlerSetCarouselComponents
                                  }
                                  activeLanguage={activeLanguage}
                                  handlerSetSlider={handlerSetSlider}
                                  id={item.id}
                                  components={selected}
                                  isRecord={isRecord}
                                  selected={selected}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  );
};

export default Carousel;
